// extracted by mini-css-extract-plugin
module.exports = {"settingsPageContainer":"SettingsPage_settingsPageContainer__1p_lE","classForTransition":"SettingsPage_classForTransition__fUyt5"};